// `ScriptSpeeches` (SuiteModel/ScriptSpeeches.swift; stage plays design, step 7): each character's speeches (cues) and the
// words of their dialogue and lyrics, parentheticals aside; a cue naming several counts for each.
import { classify, contentRange, speakersOfCue } from '../fountain.ts';
import { wordCountOfPlainText } from '../proseMarkdown.ts';

export interface SpeechCount { name: string; speeches: number; words: number }

/** Every speaker in the texts (Fountain, reading order): most words first, then most speeches, then first to speak. */
export function scriptSpeeches(texts: readonly string[]): SpeechCount[] {
  const counts = new Map<string, SpeechCount>();
  for (const text of texts) {
    let speaking: string[] = [];
    for (const line of classify(text)) {
      const [loc, len] = contentRange(line);
      switch (line.element) {
        case 'character':
          speaking = speakersOfCue(text.slice(loc, loc + len));
          for (const name of speaking) {
            const c = counts.get(name) ?? { name, speeches: 0, words: 0 };
            c.speeches += 1;
            counts.set(name, c);
          }
          break;
        case 'dialogue': case 'lyric': {
          const words = wordCountOfPlainText(text.slice(loc, loc + len));
          for (const name of speaking) counts.get(name)!.words += words;
          break;
        }
        case 'parenthetical': case 'blank': break;   // a lyric after a blank line still belongs to the speech
        default: speaking = [];
      }
    }
  }
  const order = [...counts.keys()];
  return [...counts.values()].sort((a, b) => b.words - a.words || b.speeches - a.speeches || order.indexOf(a.name) - order.indexOf(b.name));
}
